<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon">
      <em class="fas fa-truck-moving"></em>
    </span>
    {{ "ManualAllocation.Header" | translate }}
  </h1>

  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="p-fluid grid">
            <div class="col-12 mb-2">
              <small class="text-secondary">* {{ 'ManualAllocation.Search.SelectionHint' | translate }}</small>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <div class="field-radiobutton mb-2">
                <p-radioButton name="searchType" value="doNo" formControlName="searchType" inputId="searchTypeDoNo"></p-radioButton>
                <label for="searchTypeDoNo" class="ml-2">{{ "ManualAllocation.Search.DoNo" | translate }}</label>
              </div>
              <input type="text" pInputText formControlName="externOrderKey" />
              <div *ngIf="(submitted || searchForm.controls.externOrderKey.touched) && searchForm.controls.externOrderKey.errors?.required">
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <div class="field-radiobutton mb-2">
                <p-radioButton name="searchType" value="mo" formControlName="searchType" inputId="searchTypeMo"></p-radioButton>
                <label for="searchTypeMo" class="ml-2">{{ "ManualAllocation.Search.Mo" | translate }}</label>
              </div>
              <input type="text" pInputText formControlName="mo" />
              <div *ngIf="(submitted || searchForm.controls.mo.touched) && searchForm.controls.mo.errors?.required">
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">
                <span class="requiredStart">*</span>{{ "CreateDo.CreateForm.Plant" | translate }}
              </p>
              <laas-plant-dropdown
                [isSingle]="true"
                formControlName="plant">
              </laas-plant-dropdown>
              <div *ngIf="((submitted || searchForm.controls.plant.touched) && searchForm?.controls?.plant?.errors?.required )">
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
            </div>
          </div>
          <div class="col">
            <button
              pButton
              pRipple
              type="button"
              label="{{ 'Common.Button.Search' | translate }}"
              (click)="searchBtnClick()"
            ></button>
            <button
              pButton
              pRipple
              type="button"
              label="{{ 'Common.Button.Reset' | translate }}"
              class="p-button-secondary ml-4"
              (click)="resetBtnClick()"
            ></button>
          </div>
        </form>
      </p-accordionTab>

      <ng-content *ngTemplateOutlet="MOHeaderTemplate"></ng-content>
      <ng-content *ngTemplateOutlet="MODetailTemplate"></ng-content>
    </p-accordion>
  </p-card>
</div>

<!--MO Header-->
<ng-template #MOHeaderTemplate>
  <div class="mt-2">
    <laas-data-table
      #MOHeader
      [value]="headerResults"
      [loading]="isHeaderLoading"
      [defaultColumns]="moHeaderColumns"
      dataKey="externOrderKey"
      [tableKey]="preferenceKeyMO"
      [selectable]="true"
      [expandable]="false"
      [paginator]="false"
      (onRowSelect)="onHeaderRowSelect($event)"
    >
      <ng-template pTemplate="caption">
        <button
          (click)="autoAllocationBtnClick($event)"
          pButton
          class="p-button-info ml-2"
          label="{{ 'ManualAllocation.WMS.Button.AutoAllocation' | translate }}"
        ></button>

        <button
          (click)="urgentBtnClick($event)"
          pButton
          class="p-button-secondary ml-2"
          label="{{ 'ManualAllocation.WMS.Button.UrgentMO' | translate }}"
        ></button>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date : "yyyy-MM-dd HH:mm:ss" : this.laasSetting.facilityTimeZone
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>
    </laas-data-table>
  </div>
</ng-template>

<!--MO Detail-->
<ng-template #MODetailTemplate>
  <div class="mt-2">
      <laas-data-table
        #MODetail
        [value]="detailResults"
        [loading]="isDetailLoading"
        [defaultColumns]="moDetailColumns"
        [tableKey]="preferenceKeyMODetail"
        [paginator]="false"
      >
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'orderLineNo'">
                <div class="overflow-text">
                  <a
                    href="javascript: void(0);"
                    (click)="allocateMO($event, rowData)"
                    >{{ rowData[col.field] }}</a
                  >
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'createDt'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date : "yyyy-MM-dd HH:mm:ss" : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
  </div>
</ng-template>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
